import { decodeMessageFromBuffer } from './message';
import { density } from './mmwaveprotocol';

export function decodeFramesFromBufferedPayload(buffer: ArrayBuffer): Array<density.protocol.openarea.v1.Frame> {
  const frames = [];

  const view = new DataView(buffer);

  let offset = 0;
  while (offset < buffer.byteLength) {
    // get delimiter value (Uint32, big-endian)
    const messageLength = view.getUint32(offset, false);

    offset += Uint32Array.BYTES_PER_ELEMENT;

    const messageBytes = buffer.slice(offset, offset + messageLength);

    offset += messageLength;

    const message = decodeMessageFromBuffer(messageBytes);

    if (message instanceof density.protocol.openarea.v1.Frame) {
      frames.push(message);
    }
  }

  return frames;
}
